import {
  type ChannelBindingSummary,
  ChannelBindingSummarySchema,
  type CreateChannelBinding,
  type UpdateChannelBinding,
} from '@sbc/domain-models/gateway';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiGet, apiSend } from './client';

const BINDINGS_KEY = ['admin', 'channel-bindings'];

export function useChannelBinding(id: string) {
  return useQuery<ChannelBindingSummary>({
    queryKey: [...BINDINGS_KEY, 'detail', id],
    queryFn: () => apiGet(`/api/admin/channel-bindings/${id}`, ChannelBindingSummarySchema),
  });
}

export function useCreateChannelBinding() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateChannelBinding) =>
      apiSend('POST', '/api/admin/channel-bindings', input, ChannelBindingSummarySchema),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: BINDINGS_KEY });
      // a binding change also moves a connection's bindingCount / detail bindings.
      void queryClient.invalidateQueries({ queryKey: ['admin', 'channel-connections'] });
    },
  });
}

export function useUpdateChannelBinding(id: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateChannelBinding) =>
      apiSend('PUT', `/api/admin/channel-bindings/${id}`, input, ChannelBindingSummarySchema),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: BINDINGS_KEY });
      // a binding change also moves a connection's bindingCount / detail bindings.
      void queryClient.invalidateQueries({ queryKey: ['admin', 'channel-connections'] });
    },
  });
}
